module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "containerVue"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2"
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "tag": "a"
    }
  }, [_c('div', {
    staticClass: "logoDiv"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.$http.options.root + '/images/alan_auto_logo.jpg',
      "alt": "AlanAutos"
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-md-4"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "tag": "li",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('a', {
    staticClass: "customPadding"
  }, [_c('i', {
    staticClass: "fa fa-home fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Portada")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/contacto",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "customPadding"
  }, [_c('i', {
    staticClass: "fa fa-phone-square fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Contacto")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-md-4"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('router-link', {
    attrs: {
      "to": "/membership/login",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "customPadding"
  }, [_c('i', {
    staticClass: "fa fa-user-o fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Mi Cuenta")])]), _vm._v(" "), (_vm.userInfo.username.length > 0) ? _c('li', [_c('a', {
    staticClass: "customPadding"
  }, [_vm._v(_vm._s(_vm.userInfo.username))])]) : _vm._e(), _vm._v(" "), (_vm.userInfo.username.length > 0) ? _c('li', [_c('Logout')], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [(_vm.userInfo.isAdmin) ? _c('AdminNav', [_vm._v(" >")]) : _vm._e()], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-95270cf2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95270cf2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gui/MainNav.vue
// module id = 125
// module chunks = 0